import { Eleicao } from "./eleicao.model";

export class Integracao  {
    constructor(
        public id?: number,
        public login?: string,
        public senha?: string,
        public url?: string,
        public eleicao?: Eleicao,
        public alterarSenhaUrl?: string,
        public logoutUrl?: string,
        public publicKey?: string,
        public privateKey?: string,
        public plataformaId?: number,
        public textoSemAcessoCandidatura?: string,
        public textoSemAcessoVotacao?: string,
        public textoForaDoPeriodoEleitoral?: string,
        public textoSessaoExpirada?: string,
    ) {   }    
}